<template>
  <div class="w-full md:w-2/3 mt-10">
    <div class="shadow rounded-t p-5">
      <div class="text-xl">Sichtbarkeitseinstellungen</div>

      <p
        class="mt-4 text-sm"
      >Handelt es sich um einen Event, dass der Öffentlichkeit zugänglich ist, oder um ein privates Ereignis? Die Sichtbarkeitseinstellungen können hier festgelegt werden.</p>

      <fieldset>
        <div class="mt-4">
          <div class="flex items-center">
            <input
              id="public"
              :value="true"
              v-model="listed"
              name="form-input"
              type="radio"
              class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
            />
            <label for="public" class="ml-3">
              <span class="block text-sm leading-5 font-medium text-gray-700">Öffentlich</span>
            </label>
          </div>
          <div class="mt-4 flex items-center">
            <input
              id="private"
              :value="false"
              v-model="listed"
              name="form-input"
              type="radio"
              class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
            />
            <label for="private" class="ml-3">
              <span class="block text-sm leading-5 font-medium text-gray-700">Privat</span>
            </label>
          </div>
        </div>
      </fieldset>
    </div>

    <div
      class="py-3 px-4 -mt-px flex justify-between items-center shadow border-t rounded-b bg-gray-50"
    >
      <div class="text-gray-800 text-sm">
        <span v-if="listed">Auffindbar auf localTicketing und den Seiten unserer Vertriebspartner.</span>
        <span v-else>Nur über den localTicketing Link aufrufbar.</span>
      </div>
      <basic-button @click="update" :loading="loading" :disabled="loading" size="sm">Speichern</basic-button>
    </div>
  </div>
</template>

<script>
import eventsClient from "@/api/central/events";

export default {
  props: ["event"],
  data() {
    return {
      listed: this.event.listed,
      loading: false,
    };
  },

  methods: {
    update() {
      this.loading = true;

      eventsClient
        .update(this.event.id, { ...this.event, listed: this.listed })
        .then(async () => {
          await this.$store.dispatch("editor/refresh");

          this.$toasted.global.saved();
        })
        .catch((error) => {
          this.$toasted.global.error();
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>